import { createSlice } from '@reduxjs/toolkit'

export interface CounterState {
    value: number
}

const initialState: CounterState = {
    value: 0,
}

export const AppSlice = createSlice({
    name: 'counter',
    initialState,
    reducers: {},
})

export const {  } = AppSlice.actions

export default AppSlice.reducer